module.exports = __webpack_public_path__ + "static/media/sura-bumper_selected.27621288.svg";